<template>
  <div class="layout-template">
    <LayoutHeader />
    <div class="subject-wrapper">
      <div class="subject-header">
        <div class="title">{{template.name}}</div>
      </div>
      <div class="subject-content">
        <div class="template-list" v-for="(item, ind) in template.subjectList" :key="ind">
          <div class="template-title">
            <span class="title">{{item.name}}</span>
            <div class="template-opeate">
              <span @click="onPre(item, ind)" :style="{opacity:item.showInd === 1?'0.5':'1'}"><svg 
 xmlns="http://www.w3.org/2000/svg"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 width="8px" height="14px">
<path fill-rule="evenodd"  fill="rgb(34, 34, 34)"
 d="M7.707,2.50 L2.757,6.999 L7.707,11.949 C8.97,12.340 8.97,12.973 7.707,13.363 C7.316,13.754 6.683,13.754 6.292,13.363 L0.636,7.706 C0.245,7.316 0.245,6.683 0.636,6.292 L6.292,0.636 C6.683,0.245 7.316,0.245 7.707,0.636 C8.97,1.26 8.97,1.659 7.707,2.50 Z"/>
</svg></span>
              <span>{{item.showInd}} / {{item.showLength}}</span>
              <span @click="onNext(item, ind)" :style="{opacity:item.showInd === item.showLength?'0.5':'1'}"><svg 
 xmlns="http://www.w3.org/2000/svg"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 width="8px" height="14px">
<path fill-rule="evenodd"  fill="rgb(34, 34, 34)"
 d="M0.636,2.50 L5.586,6.999 L0.636,11.949 C0.246,12.340 0.246,12.973 0.636,13.363 C1.27,13.754 1.660,13.754 2.50,13.363 L7.707,7.706 C8.98,7.316 8.98,6.683 7.707,6.292 L2.50,0.636 C1.660,0.245 1.27,0.245 0.636,0.636 C0.246,1.26 0.246,1.659 0.636,2.50 Z"/>
</svg></span>
            </div>
          </div>
          <div class="template-main">
            <div class="layout-item" v-for="(t, i) in item.showList" :key="i">
              <div class="template-item">
                <div class="img">
                  <div class="info">
                  
                    <button class="preview-button" title="预览模板">
                      <router-link :to="{name:'templateId',params:{templateId:t.id}}">
                      <svg-icon name="preview1" width="18px" height="12px"></svg-icon></router-link></button>
                    <button class="collect-button" title="收藏模板" @click="onCollect(t.id)"><svg-icon name="template_collect" width="16px" height="15px"></svg-icon></button>
                  </div>
                  <router-link class="temp" :to="'/editor?id=' + t.id"><img :src="t.image" v-if="item.showInd>1"/><img v-else v-lazy="t.image"/></router-link>
                    
                </div>
              <div class="title"><span>{{t.title}}</span></div>
              </div>
            </div>
            
            <div class="empty-item layout-item"></div><div class="empty-item layout-item"></div><div class="empty-item layout-item"></div><div class="empty-item layout-item"></div><div class="empty-item layout-item"></div>
          </div>

        </div>

      </div>
      
    </div>
    <div style="padding:0 10%">
    
      <LayoutFooter/></div>
  </div>
</template>

<script lang="ts">
import router from '@/router'
import { defineComponent, ref} from 'vue'
import { RecommendService } from '@/api/recommand'
import LayoutHeader from '../components/layout/Header.vue'
import LayoutFooter from '../components/layout/Footer.vue'
import { MemberService } from '@/api/member'
import { message } from 'ant-design-vue'
export default defineComponent({
  name: 'Subject',
  components: {
    LayoutHeader, LayoutFooter
  },
  setup() {
    const subjectId = ref(String(router.currentRoute.value.params.subjectId))
    const template = ref({})
    const getTemplate = async () => {
      const res = await RecommendService.getSubjectDetail(subjectId.value)
      if (res.data.data ) {
        const _data = res.data.data
        _data.subjectList.forEach((d: any) => {
          d.showList = d.pptTemplateList.slice(0,12)
          d.showInd = 1
          d.showLength = Math.ceil(d.pptTemplateList.length / 12)
        })
        template.value = _data
      }
    }
    const onNext = (res:any) => {
      if (res.showInd === res.showLength) return
      res.showInd ++
      res.showList = res.pptTemplateList.slice((res.showInd - 1) * 12, res.showInd * 12)
    }
    const onPre = (res:any) => {
       
      if (res.showInd <= 1) return

      res.showInd --
      res.showList = res.pptTemplateList.slice((res.showInd - 1) * 12, ((res.showInd) * 12))
    }
    const onCollect = async (id: any) => {
      const params = {
        contentId:id
      }
      const res = await MemberService.addCollect(params)
      if (res.data.state === 2) {
        message.success('收藏成功')
      }
      else {
        message.error(res.data.msg)
      }
      
    }
    getTemplate()
    return {
      template,
      onNext,
      onPre,
      onCollect
    }
  },
})
</script>
<style scoped lang="scss">
 .subject-wrapper {
    max-width: 1920px;
    padding: 50px 216px 20px;
    margin: 0 auto;
   .subject-header {
     .title {
       height: 150px;
       color: #000;
       font-size: 48px;
       font-weight: bold;
       text-align: center;
       display: flex;
       align-items: center;
       justify-content: center;
     }
   }
   .template-list {
    .template-title {
      padding: 20px 0;
      display: flex;
      justify-content: space-between;
      span.title {
        font-size: 24px;
        color: #000;
        font-weight: bold;
      }
      .template-opeate {
        height:40px;
        line-height: 40px;
        background: #f1f1f1;
        border-radius: 40px;
        padding: 0 15px;
        display: flex;
        align-items: center;
        width: 120px;
        justify-content: space-between;
        span {
          svg {
            cursor: pointer;
          }
        }
      }
    }
    .template-main {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .layout-item {
        width: 15.666%;
      }
      .empty-item {
        height: 0 !important;
      }
    }
   }
 }
</style>